import { useState, useEffect } from 'react'
import classNames from 'classnames'

import styles from './ScrollToTop.module.scss'

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [scrollPercentage, setScrollPercentage] = useState(0)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    const toggleVisibility = () => {
      const threshold = 30 * (window.innerHeight / 100)
      if (window.scrollY > threshold) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }

      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight
      const scrolled = window.scrollY
      const percentage = (scrolled / scrollHeight) * 100
      setScrollPercentage(percentage)
    }

    window.addEventListener('scroll', toggleVisibility)

    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  const radius = 20
  const circumference = 2 * Math.PI * radius
  const dashOffset = circumference - (scrollPercentage / 100) * circumference

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.visible]: isVisible,
      })}
    >
      <button className={styles.wrapper__content} onClick={scrollToTop} aria-label='Scroll to top'>
        <svg width='50' height='50' viewBox='0 0 50 50'>
          <circle cx='25' cy='25' r={radius} fill='none' stroke='#232f3f' strokeWidth='4' />
          <circle
            cx='25'
            cy='25'
            r={radius}
            fill='none'
            stroke='#ff9900'
            strokeWidth='4'
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            transform='rotate(-90 25 25)'
          />
          <text x='25' y='26' textAnchor='middle' dy='.3em' fontSize='18'>
            ↑
          </text>
        </svg>
      </button>
    </div>
  )
}

export default ScrollToTop
